import { injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';
import { notifications } from '@shared/utils/notifications';
import { downloadBase64, mimeByExtension } from '@shared/utils/download';

@injectable()
export class RegistrationDocModel {
  constructor() {
    makeAutoObservable(this);
  }

  downloadDoc = async (doc: any): Promise<void> => {
    try {
      // iOS/WebKit: data:-URL не скачивается по атрибуту download, а window.open('') + document.write
      // блокируется как popup — обе ветки переведены на blob: через downloadBase64.
      // MIME — из отдельного поля doc.extension: оно гарантированно содержит расширение,
      // тогда как fileName в этой модели может прийти без него.
      downloadBase64(doc.base64data, mimeByExtension(doc.extension), doc.fileName);
    } catch (err: any) {
      notifications.error(err.toString());
    }
  };
}
